import { useEffect, useState } from "react";
import styles from "./Project.module.css";
import { Button, Dropdown, Nav, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisVertical,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { ProjectDetails } from "./ProjectDetails";
import { CreateProject } from "./CreateProject";
import { useNavigate } from "react-router-dom";
import useLocalStorageState from "use-local-storage-state";
import { formatDate } from "../../Utils/helpers/commonhelper";
import { useGetRequest } from "../../Utils/hooks/QueryHandler";
import { Pagination } from "../../pages/Pagination";
import DeleteModal from "../DeleteModal";
import { toast } from "sonner";
import { DeleteRequest, GetRequest } from "../../Utils/hooks/ApiHandler";
import pugCrm_favicon from "../../Utils/assets/img/pugCrm_favicon.png";
import ProjectSkeletonLoader from "./ProjectSkeletonLoader";
import { baseURL, defaultImage } from "../../Utils/constants/constant";

const Projects = () => {
  // State management
  const [customer, setCustomer] = useLocalStorageState("customer", {
    token: {},
  });
  const navigate = useNavigate();
  const customerId = customer?.customer_details?.customer_id;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;
  const headers = {
    authentication: rf,
    Authorization: token,
  };
  const extras = { customer, setCustomer, rf, navigate };

  const [show, setShow] = useState(false);
  const [showProjectCanvas, setProjectOffcanvas] = useState(false);
  const [showTask, setShowTask] = useState(false);
  const [project_id, setProject_id] = useState();
  const [editedMode, setEditMode] = useState(false);
  const [projectListData, setProjectListData] = useState([]);
  const [projectIdForDetailPage, setProjectIdForDetailPage] = useState(null);
  const [departmentToDelete, setDepartmentToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [cardData, setCardData] = useState([]);
  // delete modal loading state
  const [loading, setLoading] = useState(false)
  // States for using pagination
  const [limit, setLimit] = useState(25);
  const [offset, setOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [inputSearch, setInputSearch] = useState("");


  console.log(cardData, "cardData")
  // Debounced search effect
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearch(inputSearch.trim());
      setOffset(0);
    }, 300);
    return () => clearTimeout(debounceTimer);
  }, [inputSearch]);

  const params = {
    limit,
    offset,
    search: search,
  };

  const {
    data: quotationData,
    error,
    refetch: fetchProjectList,
    isLoading,
    isError,
  } = useGetRequest(
    `project/fetchProjects/${customerId}/${customer?.customer_details?.id}`,
    "getProject",
    headers,
    extras,
    params
  );

  console.log(quotationData, "quotationData")

  useEffect(() => {
    fetchProjectList();
    setProjectListData([]); // Reset before setting new data

    if (quotationData?.status === "success") {
      setProjectListData(quotationData.data);
    } else if (quotationData?.status === "fail") {
      setProjectListData([]);
    } else if (isError) {
      console.error("Error fetching quotation:", error);
    }
  }, [quotationData, isError, error]);

  const pageCount = Math.ceil(quotationData?.total_count / limit);

  // Handle page change from react-paginate
  const handlePageChange = (selectedItem) => {
    setOffset(selectedItem.selected);
  };

  const handleProjectEditClicked = (project) => {
    setProject_id(project?.id);
    setEditMode(true);
    setProjectOffcanvas(true);
  };

  const handleDetailPageClicked = (project) => {
    setProjectIdForDetailPage(null);
    setProjectIdForDetailPage(project?.id);
    setShow(true);
  };

  const handleOnCloseClick = () => {
    setProjectIdForDetailPage(null);
    setShow(false);
  };

  // Trigger delete modal
  const onDelete = (id) => {
    setDepartmentToDelete(id);
    setShowDeleteModal(true);
  };
  // Confirm delete and call API
  const handleConfirmedDelete = async () => {
    setLoading(true)
    try {
      const item = projectListData.find((d) => d.id === departmentToDelete);
      if (!item) return;

      const res = await DeleteRequest(
        `project/deleteProject/${departmentToDelete}/${customer?.customer_details?.id}`,
        { headers },
        extras
      );
      if (res?.status === "success") {
        toast.success(res.message);
        await fetchProjectList();
      } else if (res.status === "fail") {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("Delete error:", error);
    } finally {
      setLoading(false)
      setShowDeleteModal(false);
      setDepartmentToDelete(null);
    }
  };

  const fetchCardData = async () => {
    try {
      const res = await GetRequest(
        `/project/projectCards/${customerId}/${customer?.customer_details?.id}`,
        { headers },
        extras
      );

      if (res.status === "fail" || res.status !== "success") {
        return toast.error(res.message);
      }

      setCardData(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, []);

  return (
    <>
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmedDelete}
        isLoading={loading}
        message="Are you sure you want to delete this item?"
      />
      <Tab.Container defaultActiveKey="tab-sales">
        <Tab.Content>
          <Tab.Pane
            className="p-0 pt-1 pb-3"
            eventKey="tab-sales"
            style={{
              border: "none",
              animation: "cardEntry 1s ease-out forwards",
            }}
          >
            <div className=" mb-0 pb-1 d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center gap-2">
                <h3
                  className=" mb-0 d-flex gap-2 align-items-center"
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: 200,
                    fontSize: "22px",
                  }}
                >
                  All Projects
                </h3>
              </div>
              <div
                className="d-flex align-items-center gap-1"
                style={{ height: "80px" }}
              >
                {/* search bar */}
                <div className=" position-relative">
                  <input
                    type="text"
                    style={{
                      fontSize: "12px",
                      paddingLeft: "58px",
                      height: "36px",
                    }}
                    className="form-control "
                    value={inputSearch}
                    onChange={(e) => {
                      setInputSearch(e.target.value);
                      setOffset(0);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        setSearch(inputSearch);
                        setOffset(0);
                      }
                    }}
                  />
                  <i
                    className="fa-solid fa-magnifying-glass"
                    style={{
                      position: "absolute",
                      marginTop: "-26px",
                      zIndex: 1,
                      marginLeft: "13px",
                    }}
                  ></i>
                  {inputSearch.length > 0 && (
                    <i
                      className="fa-solid fa-xmark"
                      style={{
                        position: "absolute",
                        marginTop: "-26px",
                        zIndex: 1,
                        right: 0,
                        marginRight: "13px",
                        cursor: "pointer",
                      }}
                      onClick={() => setInputSearch("")}
                    ></i>
                  )}
                </div>

                {/* <button
                  className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                  style={{
                    fontSize: "1rem",
                    alignItems: "center",
                    height: "36px",
                    width: "2.5rem",
                  }}
                >
                  {" "}
                  <FontAwesomeIcon
                    style={{
                      width: "15px",
                      height: "15px",
                    }}
                    icon={faFilter}
                  />
                </button> */}

                {/* <Dropdown as="div" className="dropdownsWithoutToggle">
                  <Dropdown.Toggle as={Nav.Link} className="header-link">
                    <button
                      className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                      style={{
                        fontSize: "1rem",
                        alignItems: "center",
                        height: "35px",
                        width: "2.5rem",
                      }}
                    >
                      {" "}
                      <FontAwesomeIcon
                        style={{
                          width: "15px",
                          height: "15px",
                        }}
                        icon={faGear}
                      />
                    </button>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="defaultDropdownLong main-header-dropdown header-profile-dropdown plusDrowpdown dropdown-menu-end"
                    style={{ right: "3.4rem" }}
                  >
                    <div
                      className="mb-2 mt-2 fw-bold"
                      style={{ marginLeft: "17px" }}
                    >
                      Columns Hide Show
                    </div>
                    <hr style={{ marginBottom: "0px" }} />

                    <ul
                      className="list-unstyled mb-0 ps-2"
                      style={{
                        height: "14rem",
                        paddingTop: "8px",
                        paddingBottom: "15px",
                      }}
                    >
                      <li
                        className="form-check form-check-md mb-2 setting-list"
                        style={{ padding: 0 }}
                      >
                        <input
                          className="form-check-input column-checkboxs"
                          type="checkbox"
                        />
                        <label className="form-check-label" htmlFor="home">
                          Home
                        </label>
                      </li>
                    </ul>

                    <hr style={{ marginTop: "0px", marginBottom: "0px" }} />

                    <div
                      className="text-end"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0px 22px",
                      }}
                    >
                      <div style={{ fontSize: "13px" }}>
                        <i className="fa-solid fa-circle-info"></i>{" "}
                        <span>Help</span>
                      </div>
                      <button
                        type="button"
                        className="btn btn-success btn-sm mt-3 mb-2"
                        style={{ fontSize: "0.8rem", borderRadius: "3px" }}
                        id="applyToggleColumns"
                      >
                        Apply
                      </button>
                    </div>
                  </Dropdown.Menu>
                </Dropdown> */}
                {/* <Dropdown as="div" className="dropdownsWithoutToggle">
                  <Dropdown.Toggle as={Nav.Link} className="header-link">
                    <button
                      className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                      style={{
                        fontSize: "1rem",
                        alignItems: "center",
                        height: "35px",
                        width: "2.5rem",
                      }}
                    >
                      <FontAwesomeIcon
                        style={{
                          width: "15px",
                          height: "15px",
                        }}
                        icon={faEllipsisVertical}
                      />
                    </button>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="defaultDropdownLong  plusDrowpdown dropdown-menu-end"
                    style={{ right: "3.4rem" }}
                  >
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                    >
                      {" "}
                      Edit{" "}
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                    >
                      {" "}
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
                <Button
                  style={{ height: "35px" }}
                  type="button"
                  variant="default"
                  className="btn btn-default "
                  onClick={() => {
                    setProjectOffcanvas(true);
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} /> Add
                </Button>
                {showProjectCanvas && (
                  <CreateProject
                    show={showProjectCanvas}
                    setProjectOffcanvas={setProjectOffcanvas}
                    editedMode={editedMode}
                    setEditMode={setEditMode}
                    project_id={project_id}
                    setProject_id={setProject_id}
                    fetchProjectList={fetchProjectList}
                  />
                )}
              </div>

            </div>
            <div style={{
              textAlign: 'end',
              paddingRight: '3px',
              color: '#8798adcc',
              fontWeight: '300',
              fontSize: '11px',
              textTransform: 'capitalize',
              marginTop: '-19px', // Adjust this value as needed
            }}>
              Customize Column View | Filter Project | Short by ascending & Descending Order
            </div>
            {isLoading ? (
              <ProjectSkeletonLoader />
            ) : (
              <>
                <Tab.Container >
                  <Nav
                    // variant="pills"
                    className="nav-style-1 mt-2 mb-0 d-flex flex-nowrap newNavTab associatedDeals  gap-3 mx-0"
                  >
                    <Nav.Item className="me-0" style={{ minWidth: "17%" }}>
                      <Nav.Link className={`${styles["ProjectListingCards"]}`}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                          }}
                        >
                          <div style={{ flex: 1 }}>
                            <p style={{ color: "#ffff" }}>Completed Projects</p>
                            <h3 >
                              {cardData?.completed || 100}
                            </h3>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "0.5rem",
                              }}
                            >
                              <span
                                class="badge bg-white-transparent"
                                style={{ color: "#ffff" }}
                              >
                                1.5%
                                <i class="ti ti-trending-up"></i>
                              </span>
                              <span
                                style={{ fontSize: "0.8rem", color: "#ffff" }}
                              >
                                this month
                              </span>
                            </div>
                          </div>
                          <div
                            className="stat-icon-wrapper"
                            style={{
                              width: "30px",
                              height: "30px",
                              textAlign: "center",
                              fontSize: '1.5rem'
                            }}
                          >
                            <i class="fa-solid fa-circle-check" color="#fff"></i>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item className="me-0">
                      <Nav.Link className={`${styles["ProjectListingCards"]}`}>
                        <div className="stat-card">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "start",
                            }}
                          >
                            <div style={{ flex: 1 }}>
                              <p style={{ color: "#ffff" }}>Total Projects</p>
                              <h3 className="stat-value">
                                {cardData?.total || 0}
                              </h3>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                }}
                              >
                                <span class="badge bg-white-transparent">
                                  0.67%
                                  <i class="ti ti-trending-up"></i>
                                </span>
                                <span
                                  style={{ fontSize: "0.8rem", color: "#ffff" }}
                                >
                                  this month
                                </span>
                              </div>
                            </div>
                            <div
                              className="stat-icon-wrapper"
                              style={{
                                width: "30px",
                                height: "30px",
                                textAlign: "center",
                                fontSize: '1.5rem'
                              }}
                            >
                              <i class="fa-solid fa-folder-open" color="#fff"></i>
                            </div>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item className="me-0">
                      <Nav.Link className={`${styles["ProjectListingCards"]}`}>
                        <div className="stat-card">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "start",
                            }}
                          >
                            <div style={{ flex: 1 }}>
                              <p style={{ color: "#ffff" }}>Overdue Projects</p>
                              <h3 className="stat-value">
                                {cardData?.overdue || 0}
                              </h3>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                }}
                              >
                                <span class="badge bg-white-transparent">
                                  0.23%
                                  <i class="ti ti-trending-down"></i>
                                </span>
                                <span
                                  style={{ fontSize: "0.8rem", color: "#ffff" }}
                                >
                                  this month
                                </span>
                              </div>
                            </div>
                            <div
                              className="stat-icon-wrapper"
                              style={{

                                width: "30px",
                                height: "30px",
                                textAlign: "center",
                                fontSize: '1.5rem'
                              }}
                            >
                              <i class="fa-solid fa-briefcase" color="#fff"></i>
                            </div>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="me-0">
                      <Nav.Link className={`${styles["ProjectListingCards"]}`}>
                        <div className="stat-card">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "start",
                            }}
                          >
                            <div style={{ flex: 1 }}>
                              <p style={{ color: "#ffff" }}>Overdue Projects</p>
                              <h3 className="stat-value">
                                {cardData?.overdue || 0}
                              </h3>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                }}
                              >
                                <span class="badge bg-white-transparent">
                                  0.23%
                                  <i class="ti ti-trending-down"></i>
                                </span>
                                <span
                                  style={{ fontSize: "0.8rem", color: "#ffff" }}
                                >
                                  this month
                                </span>
                              </div>
                            </div>
                            <div
                              className="stat-icon-wrapper"
                              style={{

                                width: "30px",
                                height: "30px",
                                textAlign: "center",
                                fontSize: '1.5rem'
                              }}
                            >
                              <i class="fa-solid fa-briefcase" color="#fff"></i>
                            </div>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="me-0">
                      <Nav.Link className={`${styles["ProjectListingCards"]}`}>
                        <div className="stat-card">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "start",
                            }}
                          >
                            <div style={{ flex: 1 }}>
                              <p style={{ color: "#ffff" }}>Total Tasks</p>
                              <h3 className="stat-value">
                                {cardData?.pending || 0}
                              </h3>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                }}
                              >
                                <span class="badge bg-white-transparent">
                                  0.53%
                                  <i class="ti ti-trending-up"></i>
                                </span>
                                <span
                                  style={{ fontSize: "0.8rem", color: "#ffff" }}
                                >
                                  this month
                                </span>
                              </div>
                            </div>
                            <div
                              className="stat-icon-wrapper"
                              style={{
                                width: "30px",
                                height: "30px",
                                textAlign: "center",
                                fontSize: '1.5rem'
                              }}
                            >
                              <i class="fa-solid fa-clock" color="#fff"></i>
                            </div>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>

                  </Nav>

                  <Tab.Content>
                    <Tab.Pane
                      className="p-0 pt-0 "

                      style={{
                        border: "none",
                        animation: "cardEntry 1s ease-out forwards",
                      }}
                    >
                      <div className="table-responsive"></div>
                    </Tab.Pane>
                    <Tab.Pane

                      style={{
                        border: "none",
                        animation: "cardEntry 1s ease-out forwards",
                      }}
                    ></Tab.Pane>
                    <Tab.Pane
                      eventKey="Socials"
                      style={{
                        border: "none",
                        animation: "cardEntry 1s ease-out forwards",
                      }}
                    ></Tab.Pane>
                  </Tab.Content>
                </Tab.Container>

                <div className={`mt-3 p-0 ps-0 ${styles["approval-request-wrap"]}`}>
                  <div className="tab-content mt-1">
                    <div
                      className="tab-pane ps-app-request-resp-table active ps-0 pe-0"
                      id="pending-justified"
                      role="tabpanel"
                      style={{
                        minHeight: "300px",
                        padding: "0rem",
                        overflowX: "auto",
                        marginLeft: "2px",
                      }}
                    >
                      <div
                        className={`${styles["ps-table-wrapper"]} ${styles["ps-app-request-box"]}`}
                      >
                        {/* Row 1 */}
                        <table
                          className={`table mb-0 ${styles["ps-app-request-resp"]}${styles["ps-app-request-box"]}`}
                          style={{
                            height: "fit-content",
                            borderCollapse: "separate",
                            borderSpacing: " 0px 6px",
                          }}
                        >
                          <tbody style={{ width: "100%" }}>
                            {projectListData?.length > 0 ? (
                              projectListData?.map((project, index) => (
                                <tr key={project.id}>
                                  {/* Sticky Left Section */}
                                  <td
                                    style={{
                                      height: "99%",
                                      borderbottom: "1px solid #dddddd",
                                    }}
                                  >
                                    <div className="d-flex align-items-center">
                                      <div>{index + 1 + offset * limit}</div>
                                    </div>
                                  </td>

                                  {/* Contact / Name */}
                                  <td
                                    className={`${styles["ps-border-right"]} p-1 align-items-center`}
                                    style={{
                                      position: "sticky",
                                      left: "0px",
                                      margin: "0px",

                                      zIndex: 1,
                                      background: "white",
                                      borderLeft: "1px solid #d2d6db",
                                    }}
                                  >
                                    <div
                                      className="d-flex align-items-center"
                                      onClick={() => {
                                        handleDetailPageClicked(project);
                                      }}
                                    >
                                      <div
                                        className={`px-1 ${styles["approve-request-icom"]}`}
                                      >
                                        <img
                                          className={styles["userImages"]}
                                          src="https://dev.pandalms.com/upload/default/female.jpg"
                                          alt="Employee Photo"
                                        />
                                      </div>
                                      <div className="px-1">
                                        <p className={`${styles["fw-600"]}`} title={project?.contact_name} >
                                          <a href="##" style={{ fontSize: '.825rem' }}>

                                            {project?.contact_name?.length > 18
                                              ? `${project.contact_name.slice(
                                                0,
                                                18
                                              )}...`
                                              : project?.contact_name || "-"}
                                          </a>
                                        </p>
                                        <p
                                          className={`fw-300 d-flex ${styles["paragraph-sm-1"]} ${styles["ps-1-lines-text"]} `}
                                        >
                                          <a
                                            className="d-flex flex-row text-muted "

                                            href="##"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "0.75rem",
                                            }}
                                            title={project?.email}
                                          >


                                            {project?.email?.length > 15
                                              ? `${project.email.slice(
                                                0,
                                                15
                                              )}...`
                                              : project?.email || "-"}
                                          </a>
                                        </p>

                                      </div>
                                    </div>
                                  </td>
                                  {/* Contact / Name */}
                                  <td
                                    className={`${styles["ps-border-right"]} p-1 align-items-center`}
                                    style={{
                                      position: "sticky",
                                      left: "0px",
                                      margin: "0px",

                                      zIndex: 1,
                                      background: "white",
                                      borderLeft: "1px solid #d2d6db",
                                    }}
                                  >
                                    <div
                                      className="d-flex align-items-center"
                                      onClick={() => {
                                        handleDetailPageClicked(project);
                                      }}
                                    >
                                      <div className="px-0">
                                        <p
                                          className={`fw-300 d-flex ${styles["paragraph-sm-1"]} ${styles["ps-1-lines-text"]} `}
                                        >
                                          <a
                                            className="d-flex flex-row text-muted"
                                            href="##"
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "0.75rem",
                                            }}
                                          >
                                            {/* {project.project_title || "N/A"} */}
                                            Project
                                          </a>
                                        </p>
                                        <p className={styles.Start_date} title={project?.project_title} >
                                          <a href="##">

                                            {project?.project_title?.length > 25
                                              ? `${project.project_title.slice(
                                                0,
                                                25
                                              )}...`
                                              : project?.project_title || "-"}
                                          </a>
                                        </p>
                                      </div>
                                    </div>
                                  </td>

                                  {/* Mobile (description) */}
                                  <td
                                    className={`p-2 ${styles["ps-border-right"]}`}
                                    style={{
                                      height: "98%",
                                      alignContent: "center",
                                    }}
                                  >
                                    <p
                                      className="text-muted fs-12"

                                    >
                                      Description
                                    </p>

                                    <p
                                      className={styles.Start_date}
                                      title={project?.description}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {project?.description?.length > 20
                                        ? `${project.description.slice(
                                          0,
                                          20
                                        )}...`
                                        : project?.description}
                                    </p>
                                  </td>
                                  {/*TEAM USERS*/}
                                  <td
                                    className={`p-2 ${styles["ps-border-right"]}`}
                                    style={{
                                      height: "98%",
                                      alignContent: "center",
                                    }}
                                  >
                                    <p
                                      className="text-muted fs-12"

                                    >
                                      Teams
                                    </p>

                                    <div className="avatar-list-stacked">
                                      {project?.users &&
                                        project?.users?.length > 0 ? (
                                        <>
                                          {project?.users
                                            ?.slice(0, 3)
                                            .map((member, idx) => (
                                              <span class="avatar avatar-sm avatar-rounded">
                                                {" "}
                                                <img
                                                  height="20px"
                                                  width="20px"
                                                  key={idx}
                                                  title={member?.user_name}
                                                  src={
                                                    member.profile_img ===
                                                      null ||
                                                      member.profile_img ===
                                                      "null"
                                                      ? defaultImage
                                                      : `${baseURL}/${member.profile_img}`
                                                  }
                                                  alt={member.name || "User"}
                                                  className="avatar-item"
                                                />
                                              </span>
                                            ))}
                                          {project.users?.length > 3 && (
                                            <div className="avatar avatar-sm bg-primary avatar-rounded text-fixed-white">
                                              +{project?.users.length - 3}
                                            </div>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          <span class="avatar avatar-sm avatar-rounded">
                                            <img
                                              src={
                                                defaultImage ||
                                                "/placeholder.svg"
                                              }
                                              alt="Dummy User 3"
                                              className="avatar-item"
                                            />
                                          </span>
                                        </>
                                      )}
                                    </div>
                                  </td>
                                  {/* Start Date */}
                                  <td
                                    className={`p-3 ${styles["ps-border-right"]} enq-enquiry-date`}
                                    style={{
                                      height: "98%",
                                      alignContent: "center",
                                    }}
                                  >
                                    <p
                                      className={styles["ps-text-grey"]}

                                    >
                                      <i className="bi bi-calendar-check"></i>{" "}
                                      Start Date
                                    </p>
                                    <p className={styles.Start_date}>

                                      {formatDate(project.start_date)}

                                    </p>
                                  </td>

                                  {/* End Date */}
                                  <td
                                    className={`p-3 ${styles["ps-border-right"]} enq-enquiry-date`}
                                    style={{
                                      height: "98%",
                                      alignContent: "center",
                                    }}
                                  >
                                    <p
                                      className={styles["ps-text-grey"]}

                                    >
                                      <i className="bi bi-calendar-check"></i>{" "}
                                      End Date
                                    </p>
                                    <p className={styles.Start_date}>

                                      {project.end_date}

                                    </p>
                                  </td>

                                  {/* Status */}
                                  <td
                                    className={`p-1 ${styles["ps-border-right"]}`}
                                    style={{
                                      height: "98%",
                                      alignContent: "center",
                                    }}
                                  >
                                    <p className={styles["ps-text-grey"]}>
                                      Status
                                    </p>
                                    {project?.status === "Active" ? (
                                      <p
                                        className={`${styles["fw-600"]} text-success ${styles["paragraph-sm-1"]}`}
                                      >
                                        {project.status.toUpperCase()}
                                      </p>
                                    ) : project?.status === "Pending" ? (
                                      <p
                                        className={`${styles["fw-600"]} text-warring  ${styles["paragraph-sm-1"]}`}
                                      >
                                        {project.status.toUpperCase()}
                                      </p>
                                    ) : (
                                      <p
                                        className={`${styles["fw-600"]} text-danger ${styles["paragraph-sm-1"]}`}
                                      >
                                        {project.status.toUpperCase()}
                                      </p>
                                    )}
                                  </td>

                                  {/* Actions */}
                                  <td style={{ position: "sticky", right: 0 }}>
                                    <Dropdown
                                      as="div"
                                      className="dropdownsWithoutToggle"
                                    >
                                      <Dropdown.Toggle
                                        className="header-link"
                                        as={Nav.Link}
                                        style={{
                                          cursor: "pointer",
                                          padding: 0,
                                        }}
                                      >
                                        <FontAwesomeIcon
                                          icon={faEllipsisVertical}
                                          style={{
                                            fontSize: "16px",
                                            color: "#64748b",
                                          }}
                                        />
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu
                                        align="end"
                                        className="dropdown-menu"
                                        style={{ marginRight: "50px" }}
                                      >
                                        <Dropdown.Item
                                          href="#"
                                          className="d-flex align-items-center"
                                          onClick={() => {
                                            handleProjectEditClicked(project);
                                          }}
                                        >
                                          Edit
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          href="#"
                                          className="d-flex align-items-center"
                                          title="Delete"
                                          onClick={() => onDelete(project.id)}
                                        >
                                          Delete
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <>
                                <div
                                  className="d-flex flex-column justify-content-center align-items-center bg-white"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    minHeight: "400px",
                                  }}
                                >
                                  <div
                                    className="d-flex flex-column align-items-center justify-content-center gap-3"
                                    style={{
                                      width: "98%",
                                      height: "300px",
                                      maxHeight: "350px",
                                    }}
                                  >
                                    <img
                                      src={pugCrm_favicon || "/placeholder.svg"}
                                      alt=""
                                      height={"50px"}
                                    />

                                    <div
                                      className="d-flex flex-column justify-content-center align-items-center gap-2"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setProjectOffcanvas(true);
                                      }}
                                    >
                                      <p>Create your project</p>
                                      <Button
                                        style={{ height: "35px" }}
                                        type="button"
                                        variant="default"
                                        className="btn btn-default"
                                        onClick={() => {
                                          setProjectOffcanvas(true);
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faPlus} /> Create
                                        Project
                                      </Button>
                                    </div>

                                    {showProjectCanvas && (
                                      <CreateProject
                                        show={showProjectCanvas}
                                        setProjectOffcanvas={
                                          setProjectOffcanvas
                                        }
                                        editedMode={editedMode}
                                        setEditMode={setEditMode}
                                        project_id={project_id}
                                        setProject_id={setProject_id}
                                        fetchProjectList={fetchProjectList}
                                      />
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Tab.Pane>
        </Tab.Content>
        {projectListData?.length > 0 ? (
          <div className="pagination-container d-flex justify-content-between align-items-center gap-2 mt-0 mb-3">
            <p className="mb-0" style={{ fontSize: "14px" }}>
              Showing {offset + 1} of {pageCount}
            </p>

            <div className="d-flex ">
              <select
                style={{ width: "78px", minWidth: "78px" }}
                onChange={(e) => {
                  setLimit(Number(e.target.value));
                  setOffset(0);
                }}
                id="limit"
                className="form-control form-select"
              >
                <option value={25}>25</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="300">300</option>
              </select>

              <div className="d-flex align-items-center gap-3 ">
                <Pagination
                  offset={offset}
                  setOffset={setOffset}
                  handlePageChange={handlePageChange}
                  pageCount={pageCount}
                />
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </Tab.Container>

      <ProjectDetails
        show={show}
        onClose={() => handleOnCloseClick()}
        projectIdForDetailPage={projectIdForDetailPage}
        setProjectIdForDetailPage={setProjectIdForDetailPage}
      />
    </>
  );
};

export default Projects;
